/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfigurationLocationComponent } from './configuration-location.component';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { SysqueFrameModule } from '../../../../../../../shared/ui/src/lib/components/sysque-frame';
import { RouterModule, Routes } from '@angular/router';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [{ path: 'dialog/configuration-location-dialog', component: ConfigurationLocationComponent }];

@NgModule({
  declarations: [ConfigurationLocationComponent],
  imports: [
    CommonModule,
    FormsModule,
    DxButtonModule,
    SysqueFrameModule,
    AlertModule,
    RouterModule.forChild(routes),
  ],
  exports: [ConfigurationLocationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConfigurationLocationModule {}
